const development = process.env.VUE_APP_FIREBASE_ENV === 'development' ||
  (!process.env.VUE_APP_FIREBASE_ENV && process.env.NODE_ENV === 'development');
export const publicOrigin = process.env.VUE_APP_PUBLIC_ORIGIN || (development ? 'https://dev.centerfiretx.com' : 'https://centerfiretx.com');
export const adminOrigin = process.env.VUE_APP_ADMIN_ORIGIN || (development ? 'https://admin.dev.centerfiretx.com' : 'https://admin.centerfiretx.com');

// Old email links and bookmarks contain /admin paths. Only allow local destinations.
export function staffDestination(value) {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//') || /[\\\r\n]/.test(value)) return '/';
  const destination = value.replace(/^\/admin(?=\/|\?|#|$)/, '').replace(/^(?=[?#])/, '/') || '/';
  return destination.startsWith('//') ? '/' : destination;
}
